module.exports = __webpack_public_path__ + "img/hr-tree-07-h-trunk.890c3256.png";